/**
 * A download file-name stem: runs of anything outside `[A-Za-z0-9_-]` become
 * one `-`, leading/trailing dashes are trimmed, and an empty result falls back
 * to `fallback`. The one implementation behind every grid download name.
 */
export function fileStem(value: string, fallback: string): string {
  return value.replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || fallback;
}
